import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import usePageTitle from 'hooks/usePageTitle';
import { Joyride } from 'react-joyride';
import { getJoyrideScrollOffset } from 'utils/joyrideConfig';
import PageMenu from 'components/blocks/PageMenu/PageMenu';
import DeltaCard, { deltaGroups } from './DeltaCard';
import useDeltaStore from 'stores/useDeltaStore';
import { useDeltaTour } from 'hooks/useDeltaTour';
import './DeltaNew.scss';

const DeltaNew: React.FC = () => {
  const navigate = useNavigate();
  usePageTitle('Unidad Delta');
  const breadcrumbs = ['Unidad Delta'];
  const clearWithLeave = useDeltaStore((s) => s.clearWithLeave);
  const clearWithoutLeave = useDeltaStore((s) => s.clearWithoutLeave);
  const { run, tourKey, steps, handleCallback, startTour } = useDeltaTour();

  useEffect(() => {
    clearWithLeave();
    clearWithoutLeave();
  }, []);

  useEffect(() => {
    const handler = () => startTour();
    window.addEventListener('solimat:startDeltaTour', handler);
    return () => window.removeEventListener('solimat:startDeltaTour', handler);
  }, [startTour]);

  return (
    <>
      <Joyride
        key={tourKey}
        steps={steps}
        run={run}
        onEvent={handleCallback}
        continuous
        scrollToFirstStep
        locale={{
          back: 'Anterior',
          close: 'Cerrar',
          last: 'Finalizar',
          next: 'Siguiente',
          nextWithProgress: 'Siguiente ({current} de {total})',
          open: 'Iniciar tour de ayuda',
          skip: 'Omitir tour',
        }}
        options={{
          primaryColor: '#0F1F3D',
          zIndex: 10000,
          overlayColor: 'rgba(15, 47, 73, 0.45)',
          showProgress: true,
          buttons: ['back', 'skip', 'close', 'primary'],
        } as any}
        styles={{
          beaconInner: { backgroundColor: '#F97316' },
          beaconOuter: { borderColor: '#F97316', backgroundColor: 'rgba(249, 115, 22, 0.2)' },
          tooltip: { borderRadius: 8, fontSize: 14 },
          tooltipTitle: { fontSize: 15, fontWeight: 700, textAlign: 'left' },
          tooltipContent: { textAlign: 'left' },
        }}
        scrollOffset={getJoyrideScrollOffset()}
      />
      <PageMenu title="Unidad Delta" subtitle='Comunicación de accidentes laborales al sistema DELT@' breadcrumbs={breadcrumbs} />
      <section className="delta-group">
        <div className="container">
          <div className="delta-groups">
            {deltaGroups.map((g) => (
              <section key={g.id} className="delta-group">
                <div className="delta-group__head">
                  <span className={`delta-group__dot delta-group__dot--${g.tone}`} />
                  <div>
                    <span className="delta-group__eyebrow">{g.eyebrow}</span>
                    <h2 className="delta-group__title">{g.label}</h2>
                  </div>
                </div>
                <div className="delta-grid">
                  {g.cards.map((c) => (
                    <DeltaCard key={c.id} card={c} onNavigate={navigate} />
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default DeltaNew;
